import { useContext } from "react";
import { PatientProfileType } from "src/api/types";
import { PatientContext } from "./PatientProvider";

export function usePatient<T>(selector: (patient: PatientProfileType) => T) {
  const patient = useContext(PatientContext);

  if (patient == null) {
    throw new Error("usePatient is used outside PatientProvider");
  }

  return selector(patient);
}
